import {
    HIDE_MESSAGE,
    INIT_URL,
    ON_HIDE_LOADER,
    ON_SHOW_LOADER,
    SHOW_MESSAGE,
    SIGNIN_USER,
    SIGNIN_USER_SUCCESS,
    SIGNOUT_USER,
    SIGNOUT_USER_SUCCESS,
    SIGNUP_USER,
    SIGNUP_USER_SUCCESS,
    FORGOT_MY_PASSWORD_USER,
    RESET_PASSWORD_USER,
    ACTIVATION_USER,
    INIT_REDIRECT_URL,
    UPDATE_USER
} from 'constants/ActionTypes';

export const setInitRedirectUrl = (redirectUrlObj) => {
    return {
        type: INIT_REDIRECT_URL,
        payload: redirectUrlObj
    };
};

export const userSignUp = (user) => {
    return {
        type: SIGNUP_USER,
        payload: user
    };
};
export const userSignIn = (user) => {
    return {
        type: SIGNIN_USER,
        payload: user
    };
};
export const userForgotMyPassword = (email) => {
    return {
        type: FORGOT_MY_PASSWORD_USER,
        payload: email
    };
};
export const userResetPassword = (resetPaswordObject) => {
    return {
        type: RESET_PASSWORD_USER,
        payload: resetPaswordObject
    };
};


export const userSignOut = () => {
    return {
        type: SIGNOUT_USER
    };
};
export const userSignUpSuccess = (authUser) => {
    return {
        type: SIGNUP_USER_SUCCESS,
        payload: authUser
    };
};

export const userSignInSuccess = (authUser) => {
  // //console.log("Action a gelen User : ", authUser);
    return {
        type: SIGNIN_USER_SUCCESS,
        payload: authUser
    }
};


export const userSignOutSuccess = () => {
    return {
        type: SIGNOUT_USER_SUCCESS,
    }
};

export const showAuthMessage = (message) => {
    return {
        type: SHOW_MESSAGE,
        payload: message
    };
};


export const setInitUrl = (url) => {
    return {
        type: INIT_URL,
        payload: url
    };
};

export const showAuthLoader = () => {
    return {
        type: ON_SHOW_LOADER,
    };
};

export const hideMessage = () => {
    return {
        type: HIDE_MESSAGE,
    };
};
export const hideAuthLoader = () => {
    return {
        type: ON_HIDE_LOADER,
    };
};
export const userActivation = (activationObject) => {
    return {
        type: ACTIVATION_USER,
        payload: activationObject
    };
};
export const updateUser = (user) => {
    return {
        type: UPDATE_USER,
        payload: user
    };
};
